import fetchHandler from './Handler';

export const getSingleCurrency = async (): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: 'admins/doller', // Corrected endpoint
		});
		return response;
	} catch (error) {
		console.error('Error fetching orders:', error); // Corrected error message
		throw new Error('Could not fetch orders. Please try again later.'); // Corrected error message
	}
};

// =======================================================

export const updateCurrencyValue = async (data: any, id: string): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'PATCH',
			endpoint: `admins/doller/${id}`,
			data,
		});
		return response;
	} catch (error) {
		console.error('Error updating order status:', error); // Corrected error message
		throw new Error('Could not update order status. Please try again later.'); // Corrected error message
	}
};
